angular
  .module('MyApp')
  .service('PixAutomaticoService', ['$resource', '$q', 'Configs', function ($resource, $q, Configs) {

    /**
     * POST /pix/automatico
     * @param {string|number} resp - código do responsável financeiro
     * @param {string|number} aluno - código do aluno
     * @param {number|null|undefined} cobranca - id da cobrança; null para fluxo de adesão (menu)
     * @param {boolean} [ativarRecorrenciaViaPagamento] - com cobrança: opcional (só entra no body se informado).
     *   Sem cobrança: deve ser false (adesão: recorrência fora do pagamento de boleto).
     * @param {object} [informacaoAluno] - contexto acadêmico do aluno (adesão sem cobrança e com cobrança).
     */
    this.solicitarPixAutomatico = function (resp, aluno, cobranca, ativarRecorrenciaViaPagamento, informacaoAluno) {
      var defer = $q.defer();
      if (resp == null || resp === '' || aluno == null || aluno === '') {
        defer.reject({ message: 'Informe resp e aluno.' });
        return defer.promise;
      }
      var semCobranca = cobranca == null || cobranca === '';
      var body = {
        resp: String(resp),
        aluno: String(aluno)
      };
      if (semCobranca) {
        if (ativarRecorrenciaViaPagamento !== false) {
          defer.reject({ message: 'Solicitação sem cobrança exige ativarRecorrenciaViaPagamento false.' });
          return defer.promise;
        }
        body.cobranca = null;
        body.ativarRecorrenciaViaPagamento = false;
      } else {
        body.cobranca = Number(cobranca);
        if (ativarRecorrenciaViaPagamento !== undefined && ativarRecorrenciaViaPagamento !== null) {
          body.ativarRecorrenciaViaPagamento = !!ativarRecorrenciaViaPagamento;
        }
      }
      if (informacaoAluno && typeof informacaoAluno === 'object') {
        body.informacaoAluno = informacaoAluno;
      }
      $resource(Configs.getApiServer() + '/pix/automatico', {}, {
        post: { method: 'POST', cache: false }
      }).post({}, body, function (result) {
        defer.resolve(result);
      }, function (err) {
        defer.reject(err);
      });
      return defer.promise;
    };

    /**
     * GET /pix/automatico/consulta?codAluno=&resp=&ano=&periodo=
     * @param {string|number} codAluno
     * @param {string|number} resp - código do responsável financeiro (autorização por responsável)
     * @param {string|number} ano - ano do aluno logado/selecionado
     * @param {string|number} periodo - período/semestre do aluno logado/selecionado
     */
    this.obterAutorizacaoPixAutomatico = function (codAluno, resp, ano, periodo) {
      let deferr = $q.defer();

      if (codAluno != null && codAluno !== '' && resp != null && resp !== '') {
          $resource(
              Configs.getApiServer() + '/pix/automatico/consulta?codAluno=:codAluno&resp=:resp&ano=:ano&periodo=:periodo',
              {},
              { 'query': { method: 'GET', isArray: false } }
          ).query(
              {
                  codAluno: encodeURIComponent(codAluno),
                  resp: encodeURIComponent(String(resp)),
                  ano: ano != null && ano !== '' ? encodeURIComponent(String(ano)) : '',
                  periodo: periodo != null && periodo !== '' ? encodeURIComponent(String(periodo)) : ''
              },
              function (response) {
                  // Não usar response.status como erro: muitas APIs devolvem status 200/OK/success no corpo e isso é truthy.
                  if (response == null || response === '') {
                      deferr.reject(response);
                  } else {
                      deferr.resolve(response);
                  }
              },
              function (err) {
                  deferr.reject(err);
              }
          );
      } else {
          deferr.reject('Informe codAluno e resp.');
      }

      return deferr.promise;
      };

    /**
     * GET /pix/automatico/textos-apresentacao?codAluno=&cobranca=
     * cobranca opcional (fluxo adesão: apenas codAluno).
     * @param {string|number} codAluno
     * @param {string|number|null|undefined} [cobranca] - omitido na adesão
     */
    this.obterTextosApresentacaoPixAutomatico = function (codAluno, cobranca) {
      var defer = $q.defer();
      if (codAluno == null || codAluno === '') {
        defer.reject({ message: 'Informe codAluno.' });
        return defer.promise;
      }
      var params = { codAluno: codAluno };
      if (cobranca != null && cobranca !== '') {
        params.cobranca = cobranca;
      }
      $resource(Configs.getApiServer() + '/pix/automatico/textos-apresentacao', {}, {
        get: { method: 'GET', isArray: false, cache: false }
      }).get(
        params,
        function (result) {
          defer.resolve(result);
        },
        function (err) {
          defer.reject(err);
        }
      );
      return defer.promise;
    };

  }]);
